import "./NumberOfViewers.scss"

import React, { useEffect, useState } from "react"

import { holidayApi } from "@shared/apis"
import { isWeekend, toYYYYMMDD } from "@shared/modules"

import LastDay from "./LastDay"
import Roller from "./Roller"
import Today from "./Today"

const START_HOUR = 8
const END_HOUR = 23
const LAST_DAY_INDEX = 1

const ViewersCount = () => {
  const [isEnable, setIsEnable] = useState<boolean>()
  const [lastWeekdays, setLastWeekdays] = useState<string[]>([])

  useEffect(() => {
    const getLastWeekdays = async () => {
      const { data: _lastWeekdays } = await holidayApi.get(2)

      setLastWeekdays(_lastWeekdays.map((weekday) => weekday.date))
    }

    getLastWeekdays()
  }, [])

  useEffect(() => {
    if (lastWeekdays.length === 0) return

    let timer: NodeJS.Timeout
    const isWeekday = lastWeekdays[0] === toYYYYMMDD(new Date())

    const updateEnable = () => {
      timer = setTimeout(() => {
        const now = new Date()
        const currentHour = now.getHours()

        setIsEnable(
          START_HOUR <= currentHour &&
            currentHour <= END_HOUR &&
            !isWeekend(now) &&
            isWeekday,
        )

        updateEnable()
      }, 1000)
    }

    updateEnable()

    return () => {
      clearTimeout(timer)
    }
  }, [lastWeekdays])

  return isEnable ? (
    <div className="userB">
      <Roller>
        <Today />
        <LastDay lastWeekday={lastWeekdays[LAST_DAY_INDEX]} />
      </Roller>
    </div>
  ) : null
}

export default ViewersCount
